import { render } from "./AppNotifications.vue?vue&type=template&id=1d7bbbeb&scoped=true"
import script from "./AppNotifications.vue?vue&type=script&lang=js"
export * from "./AppNotifications.vue?vue&type=script&lang=js"

import "./AppNotifications.vue?vue&type=style&index=0&id=1d7bbbeb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d7bbbeb"

export default script